import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { useCheckoutStoreContext } from '../../context';
import Text, { TEXT } from 'src/view/components/Text/Text';
import CheckoutAddressesDraft from './components/CheckoutAddressesDraft';

const CheckoutAddresses: React.FC = observer((): JSX.Element => {
  const { store: checkoutStore } = useCheckoutStoreContext();

  useEffect(() => {
    checkoutStore.prepareAddresses();
  }, [checkoutStore.dependencies.customer?.id]);

  if (!checkoutStore.isDraft && !checkoutStore.selectedAddress?.label) {
    return <></>;
  }

  return (
    <div className="d-flex align-items-center mb-4">
      <Text type={TEXT.ORDER_FIELD} text="Address" />
      {checkoutStore.isDraft ? (
        <CheckoutAddressesDraft />
      ) : (
        <p className="family-medium color-dark text-size-16 font-weight-500">{checkoutStore.selectedAddress?.label}</p>
      )}
    </div>
  );
});

export default CheckoutAddresses;
